import React, { useCallback } from 'react'
import styled from '@emotion/styled'
import { TextButton, TextButtonType, LinkButton } from 'view/components/buttons'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { Locale, Translation } from 'locale'
import * as mixins from 'view/styles/mixins'
import * as constants from 'view/styles/constants'
import { AddAssetDialog } from '../AddAssetDialog'
import orderUploadTemplateUrl from '../assets/OrderUploadTemplate.xlsx'

const OrderUploadPlaceholderWrapper = styled.div`
  ${mixins.flexCenterContent};
  flex-direction: column;
  color: ${constants.CORE_PRIMARY_6};
`

const PlaceholderNarrative1 = styled.div`
  font-family: NEXWeb;
  font-weight: ${constants.FontWeight.Medium};
  font-size: 20px;
  margin: 6px;
`

const PlaceholderNarrative2 = styled.div`
  max-width: 500px;
  font-size: 12px;
  margin: 6px;
`

const AddAssetsButton = styled(TextButton)`
  padding: 5px 10px;
  margin-top: 20px;
`

const DownloadTemplateLink = styled(LinkButton)`
  margin-top: 12px;
`

export const StagingGridPlaceholder = withModal((props: ModalConsumerProps) => {
  const { showModal } = props

  const handleAddClick = useCallback(() => {
    showModal(<AddAssetDialog />)
  }, [showModal])

  return (
    <OrderUploadPlaceholderWrapper>
      <PlaceholderNarrative1>{Locale.translate(Translation.SC_ORDER_PLACEHOLDER_NARRATIVE_1)}</PlaceholderNarrative1>
      <PlaceholderNarrative2>{Locale.translate(Translation.SC_ORDER_PLACEHOLDER_NARRATIVE_2)}</PlaceholderNarrative2>
      <AddAssetsButton type={TextButtonType.Primary} onClick={handleAddClick}>
        {Locale.translate(Translation.TC_ADD_ASSETS)}
      </AddAssetsButton>
      <DownloadTemplateLink href={orderUploadTemplateUrl} download={Locale.translate(Translation.TC_DOWNLOAD_ORDER_TEMPLATE_FILENAME)}>
        {Locale.translate(Translation.SC_DOWNLOAD_TEMPLATE)}
      </DownloadTemplateLink>
    </OrderUploadPlaceholderWrapper>
  )
})
